import * as moment from 'moment';
import _ from "lodash";
const format = {
  DATE_TIME_SS_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  DATE_FORMAT_MM_DD: 'M/D'
};
const getMonthDateCurrent = () => moment(new Date()).format(format.DATE_FORMAT_MM_DD);
const getTimeUctCurrent = () => moment.utc();

const dateInWeek = () => {
  let arr = [];
  let from = moment(new Date().setDate(new Date().getDate() - 3)).unix();
  let to = moment(new Date().setDate(new Date().getDate() + 3)).unix();
  for (let i = from; i <= to; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
}

const backAWeek = (number, day) => {
  let arr = [];
  let to = moment(new Date(`${day[1]}/${new Date().getFullYear()}`)).unix();
  let from = to - number * 86400;
  for (let i = from; i <= to; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
}

const nextAWeek = (number, day) => {
  let arr = [];
  let from = (moment(new Date(`${new Date().getFullYear()}/${day[day.length-1]}`)).unix()) + 86400;
  let to = from + number * 86400;
  for (let i = from; i <= to; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
}

const backADay = (currentDay) => {
  let item = currentDay.filter((_v, k) => k !== 0);
  let first = moment(new Date(`${item[0]}/${new Date().getFullYear()}`)).unix() - 86400;
  item.unshift(moment.unix(first).format(format.DATE_FORMAT_MM_DD));
  item.length = 7;
  return item;
};

const nextADay = (currentDay) => {
  let items = currentDay.filter((_v, k) => k !== 0);
  let d1 = `${moment(new Date(`${items[items.length - 1]}/${new Date().getFullYear()}`)).format(format.DATE_FORMAT_MM_DD)}/${new Date().getFullYear()}`;
  let curent = ((+ new Date(d1).getTime() / 1000) + 86400); //last element arr time
  items.push(moment.unix(curent).format(format.DATE_FORMAT_MM_DD));
  const ar = items.filter((m, n) => { return n !== 0 });
  return ar;
};

const getExactDate = (date) => {
  let arr = [];
  let from = new Date(moment(new Date(date)).add(3, 'days').calendar()).getTime() / 1000;
  let to = new Date(moment(new Date(date)).subtract(3, 'days').calendar()).getTime() / 1000;
  for (let i = to; i <= from; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
};

const getArrDate = (date) => {
  let dateConvert = moment(new Date(date)).format('MM/DD/YYYY');
  let arr = [];
  let from = moment(new Date().setDate(new Date(dateConvert).getDate() - 3)).unix();
  let to = moment(new Date().setDate(new Date(dateConvert).getDate() + 3)).unix();
  for (let i = from; i <= to; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
}

const aWeekBack = (number, day) => {
  let arr = [];
  let to = moment(new Date(day)).unix();
  let from = to - number * 86400;
  for (let i = from; i <= to; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
}

const aWeekNext = (number, day) => {
  let arr = [];

  let from = moment(new Date(day)).unix();
  let to = from + number * 86400;
  for (let i = from; i <= to; i += 86400) {
    arr.push(moment.unix(i).format(format.DATE_FORMAT_MM_DD));
  }
  return arr;
}

const aDayBack = (currentDay) => {
  let to = moment(new Date().setDate(new Date(currentDay).getDate() - 1)).format('MM/DD/YYYY');
  return getArrDate(to);
};

const aDayNext = (currentDay) => {
  let to = moment(new Date().setDate(new Date(currentDay).getDate() + 1)).format('MM/DD/YYYY');
  return getArrDate(to);
};

const getDateOfMonth = (month, year = new Date().getFullYear()) => {
  let time = moment(`${year}-${month}-1`, "YYYY-M-D");
  let isLeap = year => new Date(year, 1, 29).getDate() === 29;
  let daysInMonth = time.daysInMonth();
  let indexMondayFirst = time.day() === 0 ? 7 : time.day();
  const redundantMonth = [1,3,5,7,8,10,12];
  const checkLeapYear = isLeap(year);
  const checkRedundantMonth = _.includes(redundantMonth, month);
  let totalCell;
  if(checkLeapYear) {
    totalCell = (checkRedundantMonth && indexMondayFirst > 5) || (indexMondayFirst > 6)? 42 : 35;
  }else {
    if(month === 2 && indexMondayFirst === 1){
      totalCell = 28;
    }else {
      totalCell = (checkRedundantMonth && indexMondayFirst > 5) || (indexMondayFirst > 6)? 42 : 35;
    }
  }
  let result = []
  let index = 1;
  let index1 = 1;
  let time2 = time.add(-1, 'M');
  let index2 = time2.daysInMonth() - indexMondayFirst + 2;
  for (let i = 1; i <= totalCell; i++) {
    if (i >= indexMondayFirst) {
      let day1 = index > daysInMonth ? index1++ : index++;
      let month1 = index1 >= 2 ? (month > 12 ? 1 : month + 1) : month;
      let year1 = month1 === 1 && index1 > 1 ? year + 1 : year;
      result.push({
        day: day1,
        month: month1,
        year: year1,
        title: null,
        content: null,
        isLink: moment(`${year1}-${month1}-${day1}`, "YYYY-M-D").unix() < moment().unix()
      })
    } else {
      result.push({
        day: index2,
        month: time2.month() + 1,
        year: time2.year(),
        title: null,
        content: null,
        isLink: moment(`${time2.month()}-${time2.month()}-${index2++}`, "YYYY-M-D").unix() < moment().unix()
      })
    }
  }
  return result;
}

export {
  getMonthDateCurrent, getTimeUctCurrent, aWeekBack, aWeekNext, aDayBack, aDayNext,
  dateInWeek, backAWeek, nextAWeek, nextADay, backADay, getExactDate, getDateOfMonth, getArrDate
};
